import { nomadProfile } from './nomad.js'
import { trendProfile } from './trend.js'

export const PROFILES = {
  nomad: nomadProfile,
  trend: trendProfile,
}

/**
 * The active design profile. Switching this one value re-skins the whole app,
 * because tokens.js is the only source every colour, radius, shadow and font
 * resolves through.
 */
export const ACTIVE_PROFILE = 'nomad'

export const activeProfile = PROFILES[ACTIVE_PROFILE]

export default activeProfile
